export default __webpack_public_path__ + "static/media/SBI-Bank.98f06d48.webp";